module.exports = __webpack_public_path__ + "img/image-19.355531d8.jpg";